<template>
  <div id="embedDiv">
  	<iframe id="embediframe" :src="embedURL" xtitle="Contact Us | OAKE Legal" class="webform-share-iframe" frameborder="0" allow="geolocation; microphone; camera" allowtransparency="true" allowfullscreen="true" style="width:1px;min-width:100%"></iframe>
  </div>
</template>
<script>

	import { mapGetters } from 'vuex' 
	export default {
	  name: "embedmodal",
	  data: function(){
	  	return {
	  		embedURL: null

	  	}
	  },
	  methods: {
	  	
	  },
	  mounted(){

	  	this.embedURL = process.env.VUE_APP_API_DOMAIN + '/webform/' + this.embedId + '/share/iframe-resizer/4.2.10'

	  	// var embediframe = document.getElementById('embediframe')

	  	// embediframe.src = embedURL

	  	// console.log('url', baseURL)

	  	let embedDiv = document.getElementById('embedDiv')

	  	let embedScript = document.createElement('script')

	  	var src = '//cdn.jsdelivr.net/gh/davidjbradshaw/iframe-resizer@4.2.10/js/iframeResizer.min.js'

	  	embedScript.src = src

	  	embedDiv.appendChild(embedScript)

	  	setTimeout(function(){
	  		if (iFrameResize){
	  			iFrameResize({}, '.webform-share-iframe');
	  		}
	  	}, 1000)
	  	

	  

	  	
	  	
    // 	embedScript.src = src

    // 	embedDiv.appendChild(embedScript)
	  	
	  },
	  computed: {
	  	...mapGetters({ embedId: 'getEmbedId'})	
	  },
	};
</script>
<style scoped>
	.error{
		padding:10px;
		color:#CC0000;
		border:1px dotted #CC0000;
		border-radius:5px;
		margin-bottom:15px;
	}

	.errorfield{
		border:1px solid #CC0000 !important;
	}


	.webform-share-iframe .page-title{
		border:1px solid red !important;
	}
</style>